<template>
  <div>
    <under-text-sxs>
      <div slot="underline">{{ proficiencyBonus }}</div>
      Proficiency Bonus
    </under-text-sxs>
    <br>
    <under-text-area-md v-model="item.core.languages" rows="2">
      Languages
    </under-text-area-md>

    <under-text-area-md v-model="item.core.proficiencies" rows="6">
      Proficiencies
    </under-text-area-md>
  </div>
</template>

<script>
import EzModalDice from "@/components/shared/_VueEzModalDice.vue";
import UnderTextSxs from "../shared/_UnderTextSxs.vue";
import UnderTextAreaMd from "../shared/_UnderTextAreaMd.vue";

export default {
  name: "sections-base-values-solarian-conflict",
  components: {
    EzModalDice,
    UnderTextSxs,
    UnderTextAreaMd
  },
  props: ["item"],
  computed: {
    proficiencyBonus() {
      return this.$rpgv.d20.proficiencyBonus(this.item.core.experience);
    }
  }
};
</script>
